<template>
  <div :style="{ textAlign: 'center' }">
    <div :class="$style.wrapper" :style="{ marginBottom: '0.5rem' }">
      <span :class="$style.label">ซื้อเข้า</span>
    </div>
    <div :class="$style.wrapper" :style="{ marginBottom: '0.5rem' }">
      ทองรูปพรรณ
      <div :class="$style.price">
        {{ display(ornamentBuy) }}
      </div>
    </div>
    <div :class="$style.wrapper" :style="{ marginBottom: '0.5rem' }">
      ทองแท่ง
      <div :class="$style.price">
        {{ display(ingotBuy) }}
      </div>
    </div>
    <div :class="$style.wrapper" :style="{ marginBottom: '0.5rem' }">
      <span :class="$style.label">ขายออก</span>
    </div>
    <div :class="$style.wrapper" :style="{ marginBottom: '0.5rem' }">
      ทองรูปพรรณ
      <div :class="$style.price">
        {{ display(ornamentSell) }}
      </div>
    </div>
    <div :class="$style.wrapper">
      ทองแท่ง
      <div :class="$style.price">
        {{ display(ingotSell) }}
      </div>
    </div>
  </div>
</template>

<script>
import numeral from 'numeral'

const toFormattedNumber = (value, format = '0,0') =>
  numeral(value).format(format)

export default {
  props: {
    ornamentBuy: {
      type: Number,
      default: 0
    },
    ornamentSell: {
      type: Number,
      default: 0
    },
    ingotBuy: {
      type: Number,
      default: 0
    },
    ingotSell: {
      type: Number,
      default: 0
    }
  },
  methods : {
      display(value) {
        return toFormattedNumber(value)
      }
  }
}
</script>

<style src="./GoldPrice.module.scss" lang="scss" module></style>
